// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import CategoriesSection from "../components/CategoriesSection";
import CatalogSection from "../components/CatalogSection";
import CTASection from "../components/CTASection";
import AllProducts from "../components/AllProducts";


function Product() {

    return (
        <>
            <InnerHero
                title="Our Products"
                subtitle="Complete crop protection and nutrition solutions for Indian farmers."
                breadcrumb="Home"
                bgImage="/images/img/producthero.jpg"
            />
            <CategoriesSection />
            <AllProducts />
            <section className="rnd-section">
                <div className="container">
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h6 className="section-subtitle">R&D & INNOVATION</h6>
                            <h2>
                                Research Driven <span>Innovation</span>
                            </h2>
                            <p>
                                At Goodweel Crop Care, continuous research and innovation form
                                the backbone of our product development. Our R&D efforts focus
                                on improving effectiveness while reducing environmental impact.
                            </p>
                            <p>
                                Through scientific testing, field trials, and farmer feedback,
                                we create advanced formulations that perform reliably under
                                real farming conditions.
                            </p>
                            <a href="/contact" className="rnd-btn">Explore Our Innovation</a>
                        </div>

                        <div className="col-lg-6">
                            <img
                                src="/images/img/R&D.jpg"
                                alt="Agriculture Research and Innovation"
                                className="img-fluid rnd-img"
                            />
                        </div>

                    </div>
                </div>
            </section>
            <CatalogSection />
            <CTASection />


        </>
    );
}
export default Product;
